import { createReducer, on } from '@ngrx/store';
import * as fromPassesAction from '../actions/passes.action';

export const featureKey = 'passes';

export interface State {
    passesForSale: {
        data: Array<any>,
        isLoaded: Boolean
    }
    passCart: {
        passes: Array<any>,
        quantity: number,
        points: number
    }
}

export const initialState: State = {
    passesForSale: {
        data: [],
        isLoaded: false
    },
    passCart: {
        passes: [],
        quantity: 0,
        points: 0
    }
}

export const reducer = createReducer(
    initialState,
    on(fromPassesAction.getPassesForSaleSuccess, (state: State, props: any) => ({
        ...state,
        passesForSale: {data: props.data, isLoaded: true}
    })),
    on(fromPassesAction.updatePassCartSuccess, (state: State, props: any) => ({
        ...state,
        passCart: props.data,
    })),

    on(fromPassesAction.updatePassCart, (state: State, props: any) => ({
        ...state,
        passCart: props.data
    })),
    on(fromPassesAction.clearPassCart, (state: State) => ({
        ...state,
        passCart: {
            passes: [],
            quantity: 0,
            points: 0
        }
    })),
);